var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVarianceLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 4.00028C11.9647 4.00028 12.3424 4.37713 12.3425 4.84207L12.3425 17.1233L16.7996 12.6682C17.1031 12.3647 17.5805 12.3411 17.9109 12.5979L17.99 12.6682C18.2935 12.9718 18.3172 13.4492 18.0603 13.7796L17.99 13.8587L12.0954 19.7532C11.7919 20.0568 11.3145 20.0804 10.9841 19.8235L10.905 19.7532L5.00951 13.8587C4.68106 13.5299 4.68109 12.997 5.00951 12.6682C5.31308 12.3647 5.79147 12.3411 6.12182 12.5979L6.20092 12.6682L10.6579 17.1243L10.6579 4.84207C10.6581 4.37725 11.0349 4.00046 11.4997 4.00028Z",
    fill: "#F20800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarianceLow);
export default __webpack_public_path__ + "static/media/VarianceLow.e4f507d08ecf2428a2f3ec07633251e3.svg";
export { ForwardRef as ReactComponent };